<mood-admin-config-fieldset class="raster-layer-form" [formGroup]="formGroupContainer"
  legendTitle="Raster layer configuration">

  <!-- <div class="description">
    <p>
      The minimum and maximum values configured here will be used to define the color scale range when rendering the
      layers on the map. When new data is pre-processed by the system, these values are calculated, based on the initial
      configuration of the dataset. For some datasets, a cutoff value of 5% of the total pixels is defined to ensure
      outlier data (for example extreme temperature ranges) is filtered out. Without this cutoff range the spread of the
      color scale is less uniform accross the european continent.
    </p>

    <p>
      The No Data value is used to make sure the system can handle these pixel values. Without this value, these pixels
      will be rendered on the map, as well as being taken in account during any extraction of data.
    </p>
  </div> -->

  <div class="inputs">
    <div class="value-inputs">
      <mat-form-field>
        <mat-label>Minimum value</mat-label>
        <input matInput formControlName="minimum" placeholder="Minimum value" />
        <mat-error *ngIf="fieldInvalid('minimum')">Input in invalid. {{ getFieldErrorMessage('minimum') }}</mat-error>
        <mat-hint *ngIf="fieldEmpty('minimum')">Default value of 0 will be used if not specified</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Maximum value</mat-label>
        <input matInput formControlName="maximum" placeholder="Maximum value" />
        <mat-error *ngIf="fieldInvalid('maximum')">Input in invalid. {{ getFieldErrorMessage('maximum') }}</mat-error>
        <mat-hint *ngIf="fieldEmpty('maximum')">Default value of 1 will be used if not specified</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>No Data value</mat-label>
        <input matInput formControlName="no_data" placeholder="No Data value" />
        <mat-error *ngIf="fieldInvalid('no_data')">Input in invalid. {{ getFieldErrorMessage('no_data') }}</mat-error>
        <mat-hint *ngIf="fieldEmpty('no_data')">Default value of -1 will be used if not specified</mat-hint>
      </mat-form-field>
    </div>

    <div class="calculation-inputs">
      <mat-form-field>
        <mat-label>Pixel to value formula</mat-label>
        <input matInput formControlName="formula" placeholder="Pixel to value formula" />
        <mat-error *ngIf="fieldInvalid('formula')">Input in invalid. The keyword <code
            class="formula-keyword">data</code> needs to be present to represent the pixel value</mat-error>
        <mat-hint *ngIf="fieldEmpty('formula')">No formula will be applied if not specified, the pixel value will be
          assumed to be the actual value</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Fixed unit type</mat-label>
        <mat-select [formControl]="unitTypeControl" placeholder="Unit type"
          (selectionChange)="unitTypeSelected($event)">
          <mat-option [value]="customUnitValue">Custom</mat-option>
          <mat-option *ngFor="let type_entry of possible_unit_types" [value]="type_entry.unit_type">{{ type_entry.label
            }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Custom unit</mat-label>
        <input matInput formControlName="unit" placeholder="Custom unit">
      </mat-form-field>
    </div>
  </div>
</mood-admin-config-fieldset>
